import User from '@/utils/user';

const user = new User();

const routes = [
  {
    path: '/403',
    name: '403',
    component: () => import('./views/403.vue'),
    meta: {
      title: 'Доступ запрещён',
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('./views/404.vue'),
    meta: {
      title: 'Страница не найдена',
    },
  },
  {
    path: '/500',
    name: '500',
    component: () => import('./views/500.vue'),
    meta: {
      title: 'Ошибка сервера',
    },
  },

];

export default routes.map((route) => ({
  ...route,
  meta: {
    ...route.meta,
    ...user?.isOrganization ? {
      layout: 'ui-design',
    } : {},
  },
}));
